module.exports = __webpack_public_path__ + "static/img/Inform_about_leave_absence.1a07d62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Inform_about_leave_absence.jpg
// module id = McBQ
// module chunks = 7